/* @flow strict */

import * as React from 'react';
import Loader from '/client/src/components/Loader';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import _ from 'lodash';
import moment from 'moment';
import { PUT } from '/client/src/api';
import arrayMove from 'array-move';
import CssPinner from '/client/src/components/csspinner';

import './styles.scss';

class IntegrationsCardsOrder extends React.Component {
  static contextType = DefaultContainerContext;

  state = {
    events: null
  }

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      this.setState({
        events: _.get(response, 'data.result.items', [])
      });
    }
  }

  moveToTop = async (id: number | string, oldIndex: number) => {
    try {
      CssPinner(document.body, true);
      await PUT(`/api/v1/1/merchants/events/${id}/card`, {
        is_display: true,
        placement_index: 1
      });

      this.setState({
        events: arrayMove(this.state.events, oldIndex, 0)
      });

      CssPinner(document.body, false);
    } catch (e) {
      CssPinner(document.body, false);
      console.log(e);
      console.error('Can\'t change placement');
    }
  }

  render(): React.Element<'div'> {
    const {
      events
    } = this.state;

    return (
      <div className="panel-body IntegrationsCardsOrder">
        <div className="cards-order-view" style={{ minHeight: 300 }}>
          <Loader
            url={`/api/v1/1/merchants/${this.context.profileCurrent.id}/events_card?show_hide_events=true&show_collaborative_events=true&max_result_count=100&skip_count=0`}
            onLoaded={this.handleLoaded}
          >
            {_.size(events) &&
              <div className='row sortable'>
                {_.map(events, (ev: {}, evi: number): React.Element<'div'> => {
                  if (ev.is_display) {
                    return (
                      <div className="col-sm-6" key={`IntegrationsCardsOrder-${evi}`}>
                        <div className="panel panel-default sortable-item">
                          <div className="panel-heading panel-heading-gray">
                            <div className="panel-title"> &nbsp; </div>
                            <div className="panel-actions pull-right">
                              <span
                                className={`panel-action ${evi === 0 ? 'disabled' : ''}`}
                                onClick={() => {
                                  this.moveToTop(ev.id, evi);
                                }}
                              >
                                <i className="icon icon-move-up" title="Move to Top" />
                              </span>
                            </div>
                          </div>

                          <div className="panel-body" style={{ padding:0 }}>
                            <div data-bind="compose:{model:$root.getEventModel($data)}">
                              <div className="sparxo-event sparxo-event-card">
                                <div className="sparxo-event-image-warper">
                                  <div
                                    className="sparxo-event-image 1"
                                    style={{
                                      backgroundImage: `url("${ev.image_url}?maxwidth=3200&maxheight=3200&width=480&crop=(${ev.image_crop_info.x1}%2C${ev.image_crop_info.y1}%2C${ev.image_crop_info.x2}%2C${ev.image_crop_info.y2}")`
                                    }}
                                  > </div>
                                </div>
                                <div className="sparxo-event-info">
                                  <div className="sparxo-evnet-info-left">
                                    <div
                                      className="month"
                                      style={{ textTransform: 'uppercase' }}
                                    >{moment(ev.begin_time_utc).format('MMM')}</div>
                                    <div
                                      className="day"
                                      data-bind="text:date"
                                    >{moment(ev.begin_time_utc).format('DD')}</div>
                                  </div>

                                  <div className="sparxo-event-info-right">
                                    <div className="name" data-bind="text:name">{ev.name}</div>
                                    <div className="time">
                                      <i className="icon icon-clock-o" style={{ marginLeft:'1px' }} />
                                      <span data-bind="text:time">
                                        {moment(ev.begin_time_utc).format('MMM DD hh:mm a')}
                                      </span>
                                    </div>
                                    <div className="addr">
                                      <i className="icon icon-location" />
                                      <span data-bind="text:location">{ev.location}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            }
          </Loader>
        </div>
      </div>
    );
  }
}

export default IntegrationsCardsOrder;
